export const BaseUrl = "https://api.supershine-laundry.com";

// export const BaseUrl = "http://localhost:8010";

 